import { createSelector } from 'reselect';
import { BillingInformation } from './billing';
import { BillingAction, GET_BILLING_INFORMATION_SUCCESS, UPDATE_BILLING_INFORMATION_SUCCESS } from './billing.action';

export interface BillingState {
  billingInformation: BillingInformation;
}

export const initialState: BillingState = {
  billingInformation: null
};

export function billingReducer(state: BillingState = initialState, action: BillingAction): BillingState {
  switch (action.type) {
    case GET_BILLING_INFORMATION_SUCCESS:
    case UPDATE_BILLING_INFORMATION_SUCCESS:
      return {
        ...state,
        billingInformation: action.payload
      };
    default: {
      return state;
    }
  }
}

export const getBillingInformation = (state: BillingState) => state.billingInformation;

export const getMainBillingSelector = (state): BillingState => state.billing.billingInformation;
export const getBillingInformationSelector = createSelector(getMainBillingSelector, getBillingInformation);
